import React, { useState } from 'react'
import { Card } from 'react-bootstrap'
import { TikTok } from 'react-tiktok'
export const TikTokCard = (props) => {
    const media = props.media
    const [embedMedia, setEmbedMedia] = useState('')

    const requestUrl = 'https://www.tiktok.com/oembed?url=' + media.url

    return (

        <>

            <TikTok url={media.url} />

        </>
    )
}




